import Config from '../Config';
import LocalData from '../helpers/local-data';

let localPropertyData = LocalData.get(Config.LOCAL_STORAGE_TYPES.SET_PROPERTY);
let localArticlesData = LocalData.get(Config.LOCAL_STORAGE_TYPES.SET_ARTICLES);
let localTokenData = LocalData.get(Config.LOCAL_STORAGE_TYPES.SET_TOKEN);

const initialState = {
    type: null,

    property: localPropertyData ? JSON.parse(localPropertyData) : null,
    articles: localArticlesData ? JSON.parse(localArticlesData) : null,
    token: localTokenData ? JSON.parse(localTokenData) : null,
    loading: true
};

const Reducer = (state = initialState, action) => {
    switch (action.type) {
        case Config.REDUX_REDUCER_TYPES.SET_PROPERTY:

            return {
                ...state,
                ...{type: action.type, property: action.payload}
            };
        case Config.REDUX_REDUCER_TYPES.SET_ARTICLES:

            return {
                ...state,
                ...{type: action.type, articles: action.payload}
            };
        case Config.REDUX_REDUCER_TYPES.SET_LOADING:

            return {
                ...state,
                ...{type: action.type, loading: action.payload}
            };
        case Config.REDUX_REDUCER_TYPES.SET_TOKEN:

            return {
                ...state,
                ...{type: action.type, token: action.payload}
            };
        default:
            return state;
    }
};

export default Reducer;
